// This file was automatically generated from passwordResetEmailed.html.
// Please don't edit this file by hand.

goog.provide('el8.template.multiuser_access.passwordResetEmailed');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.multiuser_access.passwordResetEmailed.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8FormBox el8BoxWithHeading el8FaxFlow mt15p"><img src="/static/images/e-circle-blue.png?v=20160729" style="width:40px;position:absolute;right:25px;top:20px;" /><h3 class="el8BrandColor el8LightWeight el8AlignCenter">Check your email</h3><div class="el8CenterBlock w80p el8AlignCenter"><div class="el8LgSpacer"></div><h4>Instructions to reset your password have been sent to ', soy.$$escapeHtml(opt_data.email), '.</h4><div class="el8LgSpacer"></div><a href="', soy.$$escapeHtml(opt_data.loginUrl), '" class="el8Btn el8BtnPrimary el8BtnDefault">Back to Login</a><div class="el8SmSpacer"></div><p class="mtMd el8AlignCenter"><a href="', soy.$$escapeHtml(opt_data.viewDocumentUrl), '">I do not receive the instructions but I need access to the documents now.</a></p><div class="el8LgSpacer"></div></div></div>');
  if (!opt_sb) return output.toString();
};
